<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading0">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse0" aria-expanded="false" aria-controls="collapse0">
                Overige werkzaamheden
            </button>
        </h2>
        <div id="collapse0" class="accordion-collapse collapse" aria-labelledby="heading0"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Inkomsten uit overige werkzaamheden zijn inkomsten die iemand heeft uit werk waarvoor hij niet in
                loondienst is en die hij niet kreeg als ondernemer voor de inkomstenbelasting. Het maakt niet uit of hij
                in Nederland of
                daarbuiten werkt en uit welk land hij deze inkomsten ontvangt.
                <div class="space10"></div>

                Inkomsten uit overig werk - ook wel resultaat uit overig werkzaamheden genoemd - zijn bijvoorbeeld de
                inkomsten die iemand heeft:

                <li class="list">uit werkzaamheden via internet (bijvoorbeeld opbrengsten uit apps of handel op
                    internet)
                </li>
                <li class="list">als bezorger van kranten, folders en dergelijke</li>
                <li class="list">als artiest of beroepssporter</li>
                <li class="list">uit een persoonsgebonden budget, als alfahulp, of omdat je voor een familielid zorgt
                </li>
                <li class="list">alDs gastouder (let op! it is wellicht al voor je ingevuld in de aangifte)</li>
                <li class="list">als predikant</li>
                <li class="list">als beloning voor werk voor de onderneming van je fiscale partner</li>
                <li class="list">door voor anderen te klussen (bijvoorbeeld schoonmaakwerk of schilderwerk)</li>
                <li class="list">door huishoudelijke werkzaamheden voor anderen te verrichten</li>
                <li class="list">door cursussen of bijles te geven</li>
                <li class="list">door artikelen en boeken te schrijven</li>
                <li class="list">door lezingen (bijvoorbeeld als gastdocent) te houden</li>
                <li class="list">door een octrooi productief te maken of te verkopen</li>
                <li class="list">door vermogensbeheer waarvoor iemand meer werkzaamheden uitvoert dan normaal</li>
                <li class="list">voor incidentele adviezen</li>
                <li class="list">als lid van een gemeenteraad</li>
                <li class="list">van kostgangers</li>
                <li class="list">door vrijwilligerswerk. Alleen als de beloning hiervoor vergelijkbaar is met het loon
                    dat iemand zou
                    krijgen als die persoon in loondienst was.
                </li>
                <li class="list">uit buitengewone beloningen ('lucratief belang')</li>
                <li class="list">prijzengeld dat iemand wint in het kader van de werkzaamheden</li>
                <li class="list">uit het woningforfait van de woning die je als zakelijk beschouwt</li>
                <li class="list">als vacatiegeld. Dit is een vergoeding die bestuursleden ontvangen voor de vervulling
                    van hun
                    functie. Bijvoorbeeld het voorbereiden en bijwonen van vergaderingen.
                <li class="list">royalty’s die iemand krijgt voor iets dat hij zelf hebt gemaakt. Als iemand royalty’s
                    hebt geërfd,
                    valt de waarde ervan onder 'Overige bezittingen'.
                </li>
                <div class="space10"></div>

                Let op! Doet iemand soms een klus voor familie of vrienden tegen vergoeding van de kosten? Dan vul
                je deze inkomsten niet in. Dit zijn activiteiten in de hobby- of familiesfeer.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Inkomsten uit overige werkzaamheden
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Het gaat hier om inkomsten en onkostenvergoedingen uit overig werk. Het gaat bijvoorbeeld om bedragen
                die iemand in rekening heeft gebracht, maar ook om de inkomsten die iemand hebt ontvangen voor de
                verkoop van goederen.
                <div class="space10"></div>

                <b>Btw</b><br/>
                Vul de inkomsten en onkostenvergoedingen in, zonder btw. Komt iemand in aanmerking voor de
                kleineondernemersregeling? Vul bij inkomsten de bedragen in die de persoon hebt gefactureerd.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Kosten inzake overige werkzaamheden
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Het gaat hier om de kosten om de werkzaamheden uit te voeren.
                <div class="space10"></div>

                Denk aan aftrekbare kosten zoals:<br/>
                <li class="list">telefoon- en internetkosten</li>
                <li class="list">afschrijvingen</li>
                <li class="list">reiskosten openbaar vervoer</li>
                <li class="list">reiskosten eigen vervoer</li>
                <li class="list">vakliteratuur</li>
                <li class="list">representatiekosten. Deze kosten zijn voor 80% aftrekbaar.</li>
                <li class="list">papier voor printers</li>
                <li class="list">briefpapier</li>
                <li class="list">visitekaartjes</li>
                <li class="list">porto- of frankeerkosten</li>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                Beloning voor vrijwilligerswerk
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Werkt iemand als vrijwilliger voor een niet-commerciële instelling en kreeg hij daarvoor een beloning?
                Dan hoef je deze beloning misschien niet aan te geven.
                <div class="space10"></div>
                Was de beloning vergelijkbaar met een beloning die de persoon zou krijgen als hij hetzelfde werk in
                loondienst deed? Dan is de beloning die de persoon kreeg wél belast.
                <div class="space10"></div>

                Als de persoon 21 jaar of ouder was, mocht je maximaal € {{ this.vrijwilligerMaxPerUur }} per uur
                ontvangen. Deze beloning is onbelast. Was de persoon jonger dan 21 jaar? Dan geldt er een maximum van
                € {{ this.vrijwilligerMaxPerUurJongere | number:'1.2-2'}} per uur.
                <div class="space10"></div>

                Verder geldt dat bedragen onbelast zijn tot een maximum van € {{ this.vrijwilligerMaxPerMaand }} per
                maand en met een maximum van € {{ this.vrijwilligerMaxPerJaar | number:'1.0-0'  }} per jaar. Het maakt
                hiervoor niet uit
                hoe oud de persoon is. Was de beloning hoger dan 1 van deze 2 bedragen? Dan moet je de volledige
                beloning in de aangifte opgeven.
                <div class="space10"></div>

                Let op! Kreeg de persoon alleen een vergoeding voor kosten die hij maakte? Dan hoef je deze vergoeding
                niet aan te geven, ook al was de vergoeding hoger dan
                € {{ this.vrijwilligerMaxPerMaand | number:'1.0-0' }} per maand of
                € {{ this.vrijwilligerMaxPerJaar }} per jaar.
            </div>
        </div>
    </div>

</div>

